import { isPlatformBrowser } from '@angular/common'
import { Inject, Injectable, PLATFORM_ID } from '@angular/core'
import { AppConfig, LayoutState } from '@libs/dtos/ui/layout.dto'
import { Subject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  constructor(@Inject(PLATFORM_ID) private platformId: object) {}
  config: AppConfig = {
    ripple: true,
    inputStyle: 'filled',
    menuMode: 'static',
    colorScheme: 'light',
    dark: false,
    theme: 'aura-dark-indigo',
    scale: 14,
  }

  state: LayoutState = {
    staticMenuDesktopInactive: true,
    staticMenuMobileActive: true,
    overlayMenuActive: false,
    profileSidebarVisible: false,
    configSidebarVisible: false,
    menuHoverActive: false,
  }

  private configUpdate = new Subject<AppConfig>()

  public overlayOpen = new Subject<any>()

  configUpdate$ = this.configUpdate.asObservable()

  overlayOpen$ = this.overlayOpen.asObservable()

  onMenuToggle() {
    if (this.isOverlay()) {
      this.state.overlayMenuActive = !this.state.overlayMenuActive
      if (this.state.overlayMenuActive) {
        this.overlayOpen.next(null)
      }
    }

    if (this.isDesktop()) {
      this.state.staticMenuDesktopInactive = !this.state.staticMenuDesktopInactive
    } else {
      this.state.staticMenuMobileActive = !this.state.staticMenuMobileActive

      if (this.state.staticMenuMobileActive) {
        this.overlayOpen.next(null)
      }
    }
  }

  closeMenuForce() {
    this.state.staticMenuDesktopInactive = true
    this.state.staticMenuMobileActive = false
    this.overlayOpen.next(null)
  }

  showProfileSidebar() {
    this.state.profileSidebarVisible = !this.state.profileSidebarVisible
    if (this.state.profileSidebarVisible) {
      this.overlayOpen.next(null)
    }
  }

  showConfigSidebar() {
    this.state.configSidebarVisible = true
  }

  isOverlay() {
    return this.config.menuMode === 'overlay'
  }

  isDesktop() {
    if (!isPlatformBrowser(this.platformId)) {
      return true
    }
    return window.innerWidth > 991
  }

  isMobile() {
    return !this.isDesktop()
  }

  onConfigUpdate() {
    this.configUpdate.next(this.config)
  }
}
